import React from "react";
import { styled } from "@mui/material/styles";

const HighlightSpan = styled("span")(({ theme }) => ({
  backgroundColor: theme.palette.warning.light,
  padding: "0 2px",
  borderRadius: "2px",
}));

interface TextHighlightProps {
  text: string;
  highlight: string | string[];
}

const TextHighlight: React.FC<TextHighlightProps> = ({ text, highlight }) => {
  // If no highlight or empty string/array, return the text as is
  if (!highlight || (Array.isArray(highlight) && highlight.length === 0) || 
      (typeof highlight === "string" && !highlight.trim())) {
    return <>{text}</>;
  }

  // Convert highlight to array if it is a string
  const terms = Array.isArray(highlight) ? highlight : [highlight];
  
  // Filter out empty terms
  const validTerms = terms.filter(term => term && term.trim());
  
  if (validTerms.length === 0) {
    return <>{text}</>;
  }

  // Create a regex pattern for all terms combined
  const pattern = validTerms.map(term => term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
  const regex = new RegExp(`(${pattern})`, "gi");
  
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) => {
        // Check if this part matches any of the highlight terms
        const isHighlighted = validTerms.some(term => 
          term && part.toLowerCase() === term.toLowerCase()
        );
        
        return isHighlighted ? (
          <HighlightSpan key={i}>{part}</HighlightSpan>
        ) : (
          part
        );
      })}
    </>
  );
};

export default TextHighlight;
